import React from "react";
import styles from "./InvidLockerSelect.module.css";

/** Physical locker bank layout for invid / invid-pickup sites (matches site schematic). */
export const INVID_SLOTS = {
  left: [
    { number: 1, sizeLetter: "S", label: "SMALL" },
    { number: 2, sizeLetter: "S", label: "SMALL" },
    { number: 3, sizeLetter: "S", label: "SMALL" },
    { number: 4, sizeLetter: "S", label: "SMALL" },
    { number: 5, sizeLetter: "L", label: "LARGE", large: true },
  ],
  right: [
    { number: 6, sizeLetter: "M", label: "MEDIUM" },
    { number: 7, sizeLetter: "M", label: "MEDIUM" },
    { number: 8, sizeLetter: "L", label: "LARGE", large: true },
  ],
};

function getSizeRecord(sizes, letter) {
  let record = sizes.find((item) => item.size === letter);
  if (!record && letter === "L") {
    record = sizes.find((item) => item.size === "XL");
  }
  return record;
}

export function findLockerForSlot(siteLockers, slotNumber) {
  if (!siteLockers?.length) return null;
  const num = String(slotNumber);
  return (
    siteLockers.find((l) => l.number === num) ||
    siteLockers.find((l) => l.number === `S-${num}`) ||
    siteLockers.find((l) => l.number === `M-${num}`) ||
    siteLockers.find((l) => l.number === `L-${num}`) ||
    siteLockers.find((l) => {
      const tail = (l.number || "").match(/(\d+)$/);
      return tail && tail[1] === num;
    })
  );
}

function isLockerAvailable(status) {
  return (status || "").toLowerCase() === "available";
}

function InvidLockerSlot({
  slot,
  sizes,
  siteLockers,
  busy,
  selectedLockerId,
  onSelectLocker,
}) {
  const sizeRecord = getSizeRecord(sizes, slot.sizeLetter);
  const locker = findLockerForSlot(siteLockers, slot.number);
  const hasLockerRecord = Boolean(locker);
  const available = hasLockerRecord
    ? isLockerAvailable(locker.status)
    : (sizeRecord?.available_lockers ?? 0) > 0;
  const statusLabel = available ? "AVAILABLE" : "OCCUPIED";
  const isSelected = locker && selectedLockerId === locker._id;
  const isDisabled = !locker || !available || busy;

  return (
    <button
      type="button"
      className={`${styles.slot} ${slot.large ? styles.slotLarge : ""} ${
        available ? styles.slotAvailableState : styles.slotOccupiedState
      } ${isSelected ? styles.slotSelected : ""} ${
        isDisabled ? styles.slotDisabled : ""
      }`}
      disabled={isDisabled}
      onClick={() => onSelectLocker(locker, sizeRecord)}
      aria-label={`Locker ${slot.number} ${slot.label}, ${statusLabel}${
        isSelected ? ", selected" : ""
      }`}
      aria-pressed={isSelected}
    >
      <span className={styles.slotNumber}>{slot.number}</span>
      <span className={styles.slotLabel}>{slot.label}</span>
      <span
        className={
          available ? styles.slotStatusAvailable : styles.slotStatusOccupied
        }
      >
        {statusLabel}
      </span>
    </button>
  );
}

const InvidLockerSelect = ({
  sizes,
  siteLockers,
  busy,
  selectedLockerId,
  onSelectLocker,
  compact = false,
}) => {
  return (
    <div className={`${styles.bankWrap} ${compact ? styles.bankWrapCompact : ""}`}>
      <div className={`${styles.bank} ${compact ? styles.bankCompact : ""}`}>
        <div className={styles.column}>
          {INVID_SLOTS.left.map((slot) => (
            <InvidLockerSlot
              key={slot.number}
              slot={slot}
              sizes={sizes}
              siteLockers={siteLockers}
              busy={busy}
              selectedLockerId={selectedLockerId}
              onSelectLocker={onSelectLocker}
            />
          ))}
        </div>

        <div className={styles.kioskColumn} aria-hidden="true">
          <div className={styles.kiosk}>
            <div className={styles.kioskScreen} />
          </div>
        </div>

        <div className={styles.column}>
          {INVID_SLOTS.right.map((slot) => (
            <InvidLockerSlot
              key={slot.number}
              slot={slot}
              sizes={sizes}
              siteLockers={siteLockers}
              busy={busy}
              selectedLockerId={selectedLockerId}
              onSelectLocker={onSelectLocker}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvidLockerSelect;
